<template>
    <div>
        <page-title>访问记录</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                      <el-form :inline="true">
                        <span class="demonstration">按月筛选</span>
                        <el-date-picker
                            size="mini"
                            @change="dateChange"
                            v-model="date"
                            type="month"
                            value-format="yyyyMM"
                            :picker-options="{disabledDate: disabledDate}"
                            placeholder="选择月份">
                        </el-date-picker>
                      </el-form>
                    </div>
                    <div>
                        <el-form :inline="true">
                            <el-form-item style="margin-bottom: 0;">
                                <el-checkbox size="mini" border v-model="quicklySelect">快速查询</el-checkbox>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 100px">
                              <el-select
                                  v-model="app_id"
                                  clearable size="mini"
                                  placeholder="平台/应用" @change="search()">
                                <el-option v-for="item in apps" :key="item.id" :label="item.display_name"
                                           :value="item.id"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0;">
                                <el-checkbox size="mini" border v-model="removeSameDomain">域名去重</el-checkbox>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 100px">
                                <el-select v-model="is_pass" clearable size="mini" placeholder="授权状态"
                                           @change="search()">
                                    <el-option v-for="item in passOptions" :key="item.value" :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 120px">
                                <el-input v-model="keyword"
                                          @keyup.enter.native="search()"
                                          size="mini"
                                          placeholder="名称/域名/服务器IP"
                                          suffix-icon="el-icon-search"/>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 100px">
                                <el-dropdown size="mini" border split-button type="primary" @command="handleCommand">
                                  导出
                                  <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="1">重复更新记录</el-dropdown-item>
                                    <el-dropdown-item command="2">ip访问记录</el-dropdown-item>
                                    <el-dropdown-item command="3">域名访问记录</el-dropdown-item>
                                    <el-dropdown-item command="4">ip访问记录(去重)</el-dropdown-item>
                                    <el-dropdown-item command="5">域名访问记录(去重)</el-dropdown-item>
                                    <el-dropdown-item command="6">访问记录</el-dropdown-item>
                                  </el-dropdown-menu>
                                </el-dropdown>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="name" label="来源">
                    <template slot-scope="scope">
                        <div>{{scope.row.domain}}</div>
                        <div>{{scope.row.ip}}</div>
                        <template v-if="scope.row.host">
                            <div style="color: #67C23A">{{scope.row.host.name}}</div>
                        </template>
                        <div>版本: {{scope.row.version}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="domain" label="请求接口">
                    <template slot-scope="scope">
                        <div>{{scope.row.request_route}}</div>
                        <div>{{scope.row.request_url}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="平台/应用名称">
                  <template slot-scope="scope">
                          <span v-if="scope.row.app">
                              {{scope.row.app.display_name}}
                          </span>
                    <span v-else>
                              SaaS平台
                          </span>
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="授权状态">
                    <template slot-scope="scope">
                        <span style="color: #F56C6C" v-if="scope.row.is_pass===0">未通过</span>
                        <span style="color: #67C23A" v-else-if="scope.row.is_pass===1">已通过</span>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="时间">
                    <template slot-scope="scope">
                        <div style="color: #909399; font-size: 12px;">{{scope.row.add_time}}</div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            passOptions: [
                {
                    value: 0,
                    label: '未通过'
                },
                {
                    value: 1,
                    label: '已通过'
                }
            ],
            loading: false,
            list: null,
            pagination: null,
            quicklySelect: true,
            removeSameDomain: false,
            is_pass: null,
            keyword: '',
            date: null,
            app_id: null,
            apps: [{'id': 0, 'display_name': 'SaaS平台'}],
            is_export: null
        }
    },
    created() {
        this.user_id = this.$route.query.user_id || null
        this.loadData(0)
        this.searchApps()
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/history/index',
                    params: {
                        app_id: this.app_id,
                        page: page,
                        is_pass: this.is_pass,
                        keyword: this.keyword,
                        quickly_select: this.quicklySelect ? 1 : null,
                        remove_same_domain: this.removeSameDomain ? 1 : null,
                        date: this.date
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        dateChange() {
            this.loadData(0)
        },
        disabledDate(time) {
            var minDate = new Date('2021-11-01');
            var maxDate = Date.now()
            return (time.getTime() > maxDate) || (time.getTime() < minDate);
        },
        searchApps() {
          axios({
            url: 'admin/app/index'
          }).then(e => {
            if (e.data.code === 0) {
              this.apps.push(...e.data.data.list)
            } else {
              this.apps = []
            }
          }).catch(e => {
            this.apps = []
          })
        },
        handleCommand(command) {
            if (!this.keyword && !(command === '1' || command === '6')) {
                this.$message.warning('请输入域名或ip')
                return
            }
            if (this.date === null) {
                this.date = ''
                if (command === '6') {
                    this.$message.warning('请选择月份')
                    return
                }
            }
            window.location.href = "/admin/history/export?keyword="
                + this.keyword + "&type=" + command + "&date=" + this.date + "&is_pass=" + this.is_pass + "&remove_same_domain=" + (this.removeSameDomain ? 1 : null);
        }
    }
}
</script>

<style scoped>
.demonstration {
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #606266;
  line-height: 20px;
  margin-right: 10px;
}
</style>
